import React, {Component} from 'react';
import {connect} from 'react-redux';

import {handleAddCard} from "../../containers/tenant/actions/billing";

class StripeCheckout extends Component {
    componentDidMount() {
        const props = this.props;
        let handler = window.StripeCheckout.configure({
            key: this.props.stripe_details.stripe_publishable_key,
            image: 'https://s3.amazonaws.com/stripe-uploads/acct_19E9NHGl5nYnvaAMmerchant-icon-1480988235664-polyrents-logo.jpg',
            locale: 'auto',
            token: function (token) {
                new Promise((resolve, reject) => {
                    props._handleSubmitPayment(token.id);
                }).then(() => {
                    props.onSuccess();
                });
            },
            closed: this.props.onClose,
            email: this.props.email,
            zipCode: true
        });

        handler.open({
            name: this.props.stripe_details.description,
            description: "This will cover you for 30 days",
            zipCode: true,
            amount: this.props.stripe_details.amount
        });
    }

    render() {
        return <div></div>;
    }
}

const mapStateToProps = (state) => ({
    stripe_details: state.tenant.billing && state.tenant.billing.stripe_details
});

const mapDispatchToProps = (dispatch) => ({
    _handleSubmitPayment(token) {
        return dispatch(handleAddCard(token));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(StripeCheckout);


// WEBPACK FOOTER //
// ./src/components/billing/StripeCheckout.js